exports = module.exports = require("./../../node_modules/css-loader/lib/css-base.js")();
// imports


// module
exports.push([module.id, ".spacer{\n    padding-top: .2em;\n}\n\n.largeSpacer {\n    padding-top: 1em;\n}\n\n.ladderTable, .drawTable {\n    width: 100%;\n}\n\ntd,th {\n    padding: .1em;\n}\n.topRow {\n    border-top: none;\n}\n\n.goalDetail {\n    font-size: .7em;\n}\n\n.currentQuater {  \n    outline: thin dotted !important;\n    outline: 5px auto -webkit-focus-ring-color !important;\n    outline-offset: -2px !important;\n}\n\n.isBye1, .isPlaceholder1 {\n    color: gray;\n}\n\n.isBye1 button {\n    display: none;\n}\n\n.tableRowLine {\n    border-top: 1px solid LightGray;\n    padding-top: 10px;\n    font-weight: bold;\n    background-color: inherit;\n}\n\n.tableHeader {\n\tborder-bottom: 1px solid LightGray;\n}\n\n.centeredText {\n    text-align: center;\n}\n\n.rightAlign {\n    text-align: right;\n}\n\n.vcenter {\n    display: inline-block;\n    vertical-align: middle;\n    float: none;\n}\n\n.goalScore {\n    padding: 10px 10px;\n}\n\n.affiliateTypeahead {\n    width: 60px;\n}\n\n.playerNameTypeahead {\n    width: 100px;\n}", ""]);

// exports



/*****************
 ** WEBPACK FOOTER
 ** ./~/css-loader!./src/css/main.css
 ** module id = 29
 ** module chunks = 1
 **/